import React from "react";
import { NavLink } from "react-router-dom";

export default function EcommerceSaaS() {
  return (
    <section className="container page-top pt-10" style={{ paddingTop: "6rem" }}>
      <div className="container">
        {/* Title Section */}
        <div className="row mb-4">
          <div className="col-12 text-center">
            <h1 className="display-5 fw-bold text-primary">eCommerce (SaaS) – Shop Easy, Save Big</h1>
            <h5 className="text-muted">
              Scalable SaaS eCommerce Solutions to Grow Your Online Store Effortlessly
            </h5>
            <hr className="w-25 mx-auto" />
          </div>
        </div>

        {/* Image and Introduction */}
        <div className="row align-items-center mb-5">
          <div className="col-md-6">
            <img
              src="https://img.freepik.com/free-vector/e-commerce-concept-illustration_114360-1071.jpg"
              alt="SaaS eCommerce Solutions"
              className="img-fluid rounded shadow"
            />
          </div>
          <div className="col-md-6">
            <h2 className="fw-semibold">Why Choose Our SaaS eCommerce Platform?</h2>
            <p>
              <strong>Bytlas Intelligence</strong> offers powerful, cloud-based eCommerce platforms designed 
              to scale with your business. Manage inventory, payments, shipping, and marketing all in one place, 
              with zero infrastructure hassles.
            </p>
            <ul className="list-group list-group-flush">
              <li className="list-group-item">✅ Easy Setup & Customizable Storefronts</li>
              <li className="list-group-item">✅ Secure Payment Gateway Integrations</li>
              <li className="list-group-item">✅ Real-time Inventory & Order Management</li>
              <li className="list-group-item">✅ SEO-Friendly & Mobile Optimized</li>
            </ul>
          </div>
        </div>

        {/* Features Section */}
        <div className="row my-5">
          <div className="col-md-6">
            <h3 className="text-secondary">Complete SaaS eCommerce Features</h3>
            <ul>
              <li>🛒 Multi-Channel Sales (Web, Mobile, Social Media)</li>
              <li>📦 Integrated Shipping & Tax Calculation</li>
              <li>📊 Detailed Sales & Customer Analytics</li>
              <li>💬 Live Chat & Customer Support Integration</li>
              <li>🔒 PCI Compliance & Data Security</li>
            </ul>
          </div>

          <div className="col-md-6">
            <h3 className="text-secondary">Grow Your Business Faster</h3>
            <p>
              Leverage our SaaS platform’s flexibility to launch new products, run promotions, 
              and expand your reach globally — all while reducing overhead costs.
            </p>
            <p>
              Our solutions empower startups and enterprises alike to deliver seamless shopping 
              experiences that customers love.
            </p>
          </div>
        </div>

        {/* CTA */}
        <div className="text-center mt-4">
          <NavLink to="/contact" className="btn btn-danger px-4 py-2 rounded-pill fw-bold">
            Start Your Online Store Today
          </NavLink>
        </div>
      </div>
    </section>
  );
}
